module.exports = __webpack_public_path__ + "img/lb-top.7871bf09.jpg";